<template>
  <div>
    <masonry v-if="dataLoaded" class="masonry" :cols="{ default: 2, 1980: 2, 600: 1 }">
      <dashboard-card
        :title="openRatingsCount.toString()"
        :text="openRatingsCount !== 0 ? $t('bf.openEvaluations') : $t('bf.noOpenEvaluation')"
        class="dashboardCard"
        @click="$emit('show', eventPayload.openRatingsCount)"
      >
      </dashboard-card>

      <dashboard-card
        :title="closedRatingsCount.toString()"
        :text="closedRatingsCount !== 0 ? $t('bf.closedEvaluations') : $t('bf.noClosedEvaluation')"
        class="dashboardCard"
        @click="$emit('show', eventPayload.closedRatingsCount)"
      >
      </dashboard-card>

      <dashboard-card
        :title="openEvaluationsCount.toString()"
        :text="openEvaluationsCount !== 0 ? $t('bf.openMag') : $t('bf.noOpenMag')"
        class="dashboardCard"
        @click="$emit('show', eventPayload.openEvaluationsCount)"
      >
      </dashboard-card>

      <dashboard-card
        :title="closedEvaluationsCount.toString()"
        :text="closedEvaluationsCount !== 0 ? $t('bf.closedMag') : $t('bf.noClosedMag')"
        class="dashboardCard"
        @click="$emit('show', eventPayload.closedEvaluationsCount)"
      >
      </dashboard-card>
    </masonry>
  </div>
</template>
<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import { CLOSED_RATINGS_COUNT, OPEN_EVALUATIONS_COUNT, OPEN_RATINGS_COUNT, CLOSED_EVALUATIONS_COUNT } from '@/common/constants';
import DashboardCard from './RatingDashboardCard.vue';
import { mapState } from 'vuex';

export default {
  components: {
    DashboardCard,
  },
  name: 'RatingDashboard',
  mixins: [common, configMixin],
  props: {
    showOnlyMyEmployees: Boolean,
  },
  data() {
    return {
      eventPayload: {
        openRatingsCount: OPEN_RATINGS_COUNT,
        closedRatingsCount: CLOSED_RATINGS_COUNT,
        openEvaluationsCount: OPEN_EVALUATIONS_COUNT,
        closedEvaluationsCount: CLOSED_EVALUATIONS_COUNT,
      },
    };
  },
  computed: {
    ...mapState('begleitfahrt', [
      'dataLoaded',
      'questionnaireById',
      'questionnaireLocalData',
      'users',
      'userById',
      'deviceUserBoss',
      'ratingsByUserId',
    ]),
    ...mapState('profile', ['user']),
    userIdsToCount() {
      if (this.showOnlyMyEmployees) {
        return this.deviceUserBoss
          .filter(
            (r) => 
              r.bossId === this.user.userId &&
              this.userById[r.userId] !== undefined &&
              this.userById[r.userId].active &&
              !this.userById[r.userId].deleted
          )
          .map((r) => r.userId);
      } else {
        return this.users.filter((u) => u.active && !u.deleted).map((u) => u.id);
      }
    },
    openRatingsCount() {
      let cnt = 0;
      for (const userId of this.userIdsToCount) {
        if (this.userById[userId]) {
          if (this.questionnaireLocalData[userId]) {
            cnt += Object.values(this.questionnaireLocalData[userId]).filter(
              (r) => this.questionnaireById[r.questionnaireId] !== undefined && r.isType === 'questionnaire'
            ).length;
          }
        }
      }
      return cnt;
    },
    closedRatingsCount() {
      let cnt = 0;
      for (const userId of this.userIdsToCount) {
        if (this.userById[userId]) {
          if (this.ratingsByUserId[userId]) {
            cnt += this.ratingsByUserId[userId].filter(
              (r) => this.questionnaireById[r.questionnaireIdFk] !== undefined && r.isType === 'questionnaire'
            ).length;
          }
        }
      }
      return cnt;
    },
    openEvaluationsCount() {
      let cnt = 0;
      for (const userId of this.userIdsToCount) {
        if (this.userById[userId]) {
          if (this.questionnaireLocalData[userId]) {
            cnt += Object.values(this.questionnaireLocalData[userId]).filter(
              (r) => this.questionnaireById[r.questionnaireId] !== undefined && r.isType === 'evaluation'
            ).length;
          }
        }
      }
      return cnt;
    },
    closedEvaluationsCount() {
      let cnt = 0;
      for (const userId of this.userIdsToCount) {
        if (this.userById[userId]) {
          if (this.ratingsByUserId[userId]) {
            cnt += this.ratingsByUserId[userId].filter(
              (r) => this.questionnaireById[r.questionnaireIdFk] !== undefined && r.isType === 'evaluation'
            ).length;
          }
        }
      }
      return cnt;
    },
  },
};
</script>

<style scoped>
.theme--dark .masonry {
  padding: 1.5rem 0 0 1.5rem;
  background: #202020;
}
.theme--light .masonry {
  padding: 1.5rem 0 0 1.5rem;
  background: white;
}
.dashboardCard {
  margin: 0 1.5rem 1.5rem 0;
}
</style>
